import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Modal from '../components/Modal';
import TenantForm from '../components/TenantForm';
import api from '../api';

export default function Apartments() {
  const { addr, num } = useParams();
  const [apartments, setApartments] = useState([]);
  const [editTenant, setEditTenant] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { fetchApartments(); }, [addr, num]);

  async function fetchApartments() {
    const res = await api.get(`/apartments/${addr}/${num}/with-tenants`);
    setApartments(res.data);
  }

  async function handleSaveTenant(form) {
    await api.put(`/tenants/${form.id}`, form);
    setEditTenant(null);
    fetchApartments();
  }

  return (
    <div>
      <Navbar title={`בניין: ${decodeURIComponent(addr)} ${num}`} breadcrumb="פרויקטים > בניינים > דירות" />
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 className="page-title">דירות</h2>
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>← חזור</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>דירה</th>
              <th>קומה</th>
              <th>סטטוס</th>
              <th>צפון/מזרח</th>
              <th>דיירים</th>
              <th>פרטים</th>
            </tr>
          </thead>
          <tbody>
            {apartments.map(apt => (
              <tr key={apt.apartmentNumber}>
                <td><strong>{apt.apartmentNumber}</strong></td>
                <td>{apt.floor}</td>
                <td>{apt.apartmentStatus || '—'}</td>
                <td>{[apt.isNorth ? 'צפון' : null, apt.isEast ? 'מזרח' : null].filter(Boolean).join(' / ') || '—'}</td>
                <td>
                  {apt.tenants.length === 0 ? (
                    <span style={{ color: '#9ca3af' }}>אין דיירים</span>
                  ) : (
                    apt.tenants.map(t => (
                      <span
                        key={t.id}
                        onClick={() => setEditTenant(t)}
                        style={{
                          display: 'inline-block',
                          marginLeft: 6,
                          padding: '2px 10px',
                          background: '#e0e7ff',
                          borderRadius: 12,
                          cursor: 'pointer',
                          fontSize: '0.9rem',
                          color: '#1a56db'
                        }}
                      >
                        {t.firstName} {t.lastName}
                      </span>
                    ))
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-secondary"
                    style={{ padding: '4px 10px', fontSize: '0.8rem' }}
                    onClick={() => navigate(`/apartment/${addr}/${num}/${apt.apartmentNumber}`)}
                  >
                    פתח
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editTenant && (
        <Modal title={`עריכת דייר - ${editTenant.firstName} ${editTenant.lastName}`} onClose={() => setEditTenant(null)}>
          <TenantForm initial={editTenant} onSubmit={handleSaveTenant} onCancel={() => setEditTenant(null)} />
        </Modal>
      )}
    </div>
  );
}
